import LeadCompletedForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadCompletedForm'
import LeadContractingFinalizationForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadContractingFinalizationForm'
import LeadContractingForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadContractingForm'
import LeadContractingManagementReviewForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadContractingManagementReviewForm'
import LeadInBiddingForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadInBiddingForm'
import LeadQualifyingApprovedForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadQualifyingApprovedForm'
import LeadQualifyingForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadQualifyingForm'
import LeadQualifyingManagementReviewForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadQualifyingManagementReviewForm'
import LeadRegisteredForm from '@/features/publicCompanyLeadsFunnel/components/leadFormStates/LeadRegisteredForm'
import { stateStrategy } from '@/features/publicCompanyLeadsFunnel/constants/stateStrategy.constant'

export const leadFormStateOptions = [
  {
    value: 'registered' as keyof typeof stateStrategy,
    comp: LeadRegisteredForm,
  },
  {
    value: 'qualifying' as keyof typeof stateStrategy,
    comp: LeadQualifyingForm,
  },
  {
    value: 'qualifying_management_review' as keyof typeof stateStrategy,
    comp: LeadQualifyingManagementReviewForm,
  },
  {
    value: 'qualifying_approved' as keyof typeof stateStrategy,
    comp: LeadQualifyingApprovedForm,
  },
  {
    value: 'in_bidding' as keyof typeof stateStrategy,
    comp: LeadInBiddingForm,
  },
  {
    value: 'contracting' as keyof typeof stateStrategy,
    comp: LeadContractingForm,
  },
  {
    value: 'contracting_management_review' as keyof typeof stateStrategy,
    comp: LeadContractingManagementReviewForm,
  },
  {
    value: 'contracting_finalization' as keyof typeof stateStrategy,
    comp: LeadContractingFinalizationForm,
  },
  {
    value: 'completed' as keyof typeof stateStrategy,
    comp: LeadCompletedForm,
  },
]
